import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLoaderData, useLocation } from "react-router";
import { Link } from "react-router-dom";

import { store } from "../..";
import "../../assets/css/majorybl/pages/leagues.scss";
import Schedule from "../../components/Schedule";
import { clubhouseActions } from "../../features/clubhouse/clubhouseSlice";
import {
    leagueManagementActions,
    selectSelectedLeague,
} from "../../features/leaguemgmt/leagueManagementSlice";
import { getLeagueSchedule } from "../../lib/api";
import { IGame, ILeagueSchedule } from "../../types/api";

export const loader = async ({ params }: any) => {
    const leagues = store.getState().leaguemanagement.leagues;

    !leagues.length &&
        (await store.dispatch(leagueManagementActions.getLeagues()));

    const { schedule } = await getLeagueSchedule(params.leagueId);
    let league = selectSelectedLeague(store.getState());

    if (!league) {
        store.dispatch(
            leagueManagementActions.setSelectedLeague(
                parseInt(params.leagueId),
            ),
        );
    }

    store.dispatch(clubhouseActions.setSelectedTeam(undefined));
    league = selectSelectedLeague(store.getState());

    const header = league
        ? `${league.ageLevel}${
              league.designation ? ` ${league.designation}` : ""
          }${league.direction ? ` ${league.direction}` : ""} Schedule`
        : "League Schedule";

    return {
        leagueId: params.leagueId,
        schedule,
        header,
    };
};

const LeagueSchedule = (): React.JSX.Element => {
    const { schedule: loadedSchedule, leagueId } = useLoaderData() as {
        leagueId: number;
        schedule: ILeagueSchedule;
    };
    const [schedule, setSchedule] = useState<IGame[]>(
        loadedSchedule?.games || [],
    );

    const location = useLocation();
    const isOnSchedulePage =
        /league-management\/league\/\d+\/schedule\/?$/.test(location.pathname);

    const scheduled = schedule?.filter(g => !["Postponed"].includes(g.status));

    const postponed = schedule?.filter(g => g.status === "Postponed");

    return isOnSchedulePage ? (
        <div data-testid="leagueScheduleContent">
            <Container fluid="xs">
                <Row>
                    <Col>
                        <Link
                            to={`/league-management/league/${leagueId}/schedule/create-game`}
                            className="btn btn-primary"
                        >
                            Create Game
                        </Link>
                    </Col>
                </Row>
                {!schedule && !postponed && (
                    <Row>
                        <Col>
                            <h2>No scheduled games</h2>
                        </Col>
                    </Row>
                )}
                {schedule && (
                    <Row>
                        <Col>
                            <Schedule
                                schedule={
                                    scheduled?.filter(
                                        g => g.isPlayoff === 0,
                                    ) as IGame[]
                                }
                                setSchedule={setSchedule}
                                scheduleHeader="League Schedule"
                                showButtons={true}
                                scheduleType="league"
                            />
                        </Col>
                    </Row>
                )}
                {postponed && (
                    <Row>
                        <Col>
                            <Schedule
                                schedule={postponed?.filter(
                                    g => g.isPlayoff === 0,
                                )}
                                setSchedule={setSchedule}
                                scheduleHeader="Postponed Games"
                                showButtons={true}
                                scheduleType="league"
                            />
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    ) : (
        <Outlet context={{ schedule, setSchedule }} />
    );
};

export default LeagueSchedule;
